import React, { useCallback, useEffect } from "react";
import { Input } from "../../ui/Input";
import { MultiTextInput } from "../../ui/MultiTextInput";
import { Select } from "../../ui/Select";
import { SelectCountry } from "../../selectors/country/selectCountry";
import { RadioGroup } from "../../ui/RadioGroup";
import { yesNoOption } from "../../options/options";
export const TrustForm = React.memo(({formData, onChange, isReadOnly, isReport}) => {



    useEffect(() => {
        if (formData.uboIndividualSettlorType === "Yes" && formData.uboSettlorInvolved !== "No") {
          // Settlor is deceased, set involvement to "No"
          onChange({
            target: {
              name: "uboSettlorInvolved",
              value: "No"
            }
          });
        } else if (formData.uboIndividualSettlorType === "No" && formData.uboSettlorInvolved) {
          // Settlor is not deceased, clear the involvement selection
          onChange({
            target: {
              name: "uboSettlorInvolved",
              value: ""
            }
          });
        }
      }, [formData.uboIndividualSettlorType, formData.uboSettlorInvolved, onChange]);

    useEffect(()=>{
        if(formData.uboCoporateTrusteeRegulatedTrustCompany === "Yes" && formData?.uboDirectors?.length > 0){
            onChange({ target: { name: "uboDirectors", value: [] } });
        }
    }, [formData.uboCoporateTrusteeRegulatedTrustCompany, formData?.uboDirectors?.length, onChange])

    const handleUboSettlorType = useCallback((event)=>{
        const { name, value } = event.target;
        if (value === "Corporate Entity") {
            onChange({ target: { name: "uboIndividualSettlorType", value: "" } });
            onChange({ target: { name: "uboIndividualSettlorName", value: "" } });
        } else if (value === "Private Individual") {
            onChange({ target: { name: "uboCorporateSettlorName", value: "" } });
        }
        onChange({target: {name, value}});
    }, [onChange]);

    const handleUboIndividualSettlorType = useCallback((event)=>{
        const { name, value } = event.target;
        if (value === "Yes") {
            onChange({ target: { name: "uboIndividualSettlorName", value: "" } });
        }
        onChange({target: {name, value}});
    }, [onChange]);
    
    return (
        <>
            <Input
                label={"Name of Trust"}
                name={"uboTrustName"}
                value={formData.uboTrustName}
                disabled={isReadOnly}
                onChange={onChange}
                isReport={isReport}
                required
            />

            <Select
                label={"Type of Trust"}
                name={"uboTrustType"}
                value={formData.uboTrustType}
                disabled={isReadOnly}
                onChange={onChange}
                isReport={isReport}
                required
                options={[
                    { value: "Discretionary", display_value: "Discretionary" },
                    { value: "Bare Trust", display_value: "Bare Trust" },
                    { value: "Accumulation Trust", display_value: "Accumulation Trust" },
                    { value: "Non-resident Trust", display_value: "Non-resident Trust" },
                    { value: "Charitable Trust", display_value: "Charitable Trust" },
                    { value: "Pension Trust", display_value: "Pension Trust" },
                ]}
            />

            {(formData.uboTrustType === "Discretionary" || 
                formData.uboTrustType === "Accumulation Trust" || 
                formData.uboTrustType === "Charitable Trust" || 
                formData.uboTrustType === "Pension Trust" ) && (<>
                    <MultiTextInput 
                        label={"Class of Beneficiaries"}
                        name={"uboTrustClassOfBeneficiaries"}
                        values={formData.uboTrustClassOfBeneficiaries || []}
                        onChange={onChange}
                        disabled={isReadOnly}
                        isReport={isReport}
                    />   
                </>)}

            {(formData.uboTrustType === "Non-resident Trust" || formData.uboTrustType === "Bare Trust") && (<>
                    <MultiTextInput 
                        label={"Full Name of Beneficiaries"}
                        name={"uboTrustFullNameOfBeneficiaries"}
                        values={formData.uboTrustFullNameOfBeneficiaries || []}
                        onChange={onChange}
                        disabled={isReadOnly}
                        isReport={isReport}
                    />
            </>)}
            <RadioGroup 
                label={"Is the Settlor a Corporate Entity or Private Individual?"}
                name={"uboSettlorType"}
                value={formData.uboSettlorType}
                onChange={handleUboSettlorType}
                disabled={isReadOnly}
                isReport={isReport}
                options={[
                    { value: "Corporate Entity", display_value: "Corporate Entity" },
                    { value: "Private Individual", display_value: "Private Individual" }
                ]}
            />
            {(formData.uboSettlorType === "Corporate Entity") &&(
                <Input 
                label={"Name of Settlor"}
                name={"uboCorporateSettlorName"}
                value={formData.uboCorporateSettlorName}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />

            )}
            {(formData.uboSettlorType === "Private Individual") &&(
                <>
                <RadioGroup 
                isReport={isReport}
                label={"Is the Settlor deceased?"}
                name={"uboIndividualSettlorType"}
                value={formData.uboIndividualSettlorType}
                onChange={handleUboIndividualSettlorType}
                disabled={isReadOnly}
                options={yesNoOption}
            />
            {(formData.uboIndividualSettlorType === "No") &&(
                <Input 
                isReport={isReport}
                label={"Name of Settlor"}
                name={"uboIndividualSettlorName"}
                value={formData.uboIndividualSettlorName}
                onChange={onChange}
                disabled={isReadOnly}
            /> 
            )}
            </>

            )}
            

            

            {/* <RadioGroup 
                label={"Is the Settlor still involved with the trust?"}
                name={"uboSettlorInvolved"}
                value={formData.uboSettlorInvolved}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
                options={[
                    { value: "Yes", display_value: "Yes" },
                    { value: "No", display_value: "No" }
                ]}
            /> */}

            <Input 
                label={"Purpose of Trust"}
                name={"uboTrustPurpose"}
                value={formData.uboTrustPurpose}
                disabled={isReadOnly}
                onChange={onChange}
                isReport={isReport}
            />

            <RadioGroup 
                label={"Is there a Protector or Controller"}
                name={"uboTrustProtectorOrController"}
                value={formData.uboTrustProtectorOrController}
                disabled={isReadOnly}
                onChange={onChange}
                isReport={isReport}
                options={[
                    { value: "Yes", display_value: "Yes" },
                    { value: "No", display_value: "No" }
                ]}
            />

            {formData.uboTrustProtectorOrController === "Yes" && (
                <Input 
                    label={"Name of Protector or Controller"}
                    name={"uboProtectorOrControllerName"}
                    value={formData.uboProtectorOrControllerName}
                    disabled={isReadOnly}
                    onChange={onChange}
                    isReport={isReport}
                />
            )}

            {/* <MultiTextInput
                label={"Trustee"}
                name={"uboTrustee"}
                values={formData.uboTrustee || []}
                onChange={onChange}
            /> */}

            <Select 
                label={"Trustee Type"}
                name={"uboTrusteeType"}
                value={formData.uboTrusteeType}
                disabled={isReadOnly}
                onChange={onChange}
                isReport={isReport}
                options={[
                    { value: "Corporate Trustee", display_value: "Corporate Trustee" },
                    { value: "Legal Person", display_value: "Legal Person" },
                    { value: "Natural Person", display_value: "Natural Person" }
                ]}
            />

            {formData.uboTrusteeType === "Corporate Trustee" && (
                <>
                    <Input 
                        label={"Name of Trustee"}
                        name={"uboCorporateTrusteeName"}
                        disabled={isReadOnly}
                        value={formData.uboCorporateTrusteeName}
                        onChange={onChange}
                        isReport={isReport}
                    />

                    <SelectCountry
                        label={"Country of Incorporation"}
                        name={"uboCorporateTrusteeCountryOfIncorporation"}
                        disabled={isReadOnly}
                        value={formData.uboCorporateTrusteeCountryOfIncorporation}
                        onChange={onChange}
                        isReport={isReport}
                    />

                    <Input 
                        label={"Registration Number"}
                        name={"uboCorporateTrusteeRegistrationNumber"}
                        disabled={isReadOnly}
                        value={formData.uboCorporateTrusteeRegistrationNumber}
                        onChange={onChange}
                        isReport={isReport}
                    />

                    <RadioGroup 
                        label={"Regulated Trust Company?"}
                        name={"uboCoporateTrusteeRegulatedTrustCompany"}
                        disabled={isReadOnly}
                        value={formData.uboCoporateTrusteeRegulatedTrustCompany}
                        onChange={onChange}
                        isReport={isReport}
                        options={[
                            { value: "Yes", display_value: "Yes" },
                            { value: "No", display_value: "No" }
                        ]}
                    />

                    {
                        formData.uboCoporateTrusteeRegulatedTrustCompany === "No" && 
                        <MultiTextInput 
                            label={"Name of Directors"}
                            name={"uboDirectors"}
                            disabled={isReadOnly}
                            values={formData.uboDirectors}
                            onChange={onChange}
                            isReport={isReport}
                        />
                    }

                </>
            )}

            {formData.uboTrusteeType === "Legal Person" && (
                <>
                    <Input 
                        label={"Company Name"}
                        name={"uboLegalPersonCompanyName"}
                        value={formData.uboLegalPersonCompanyName}
                        disabled={isReadOnly}
                        onChange={onChange}
                        isReport={isReport}
                    />

                    <SelectCountry
                        label={"Country of Incorporation"}
                        name={"uboLegalPersonCountryOfIncorporation"}
                        value={formData.uboLegalPersonCountryOfIncorporation}
                        disabled={isReadOnly}
                        onChange={onChange}
                        isReport={isReport}
                    />

                    <Input 
                        label={"Company Type"}
                        name={"uboLegalPersonCompanyType"}
                        value={formData.uboLegalPersonCompanyType}
                        disabled={isReadOnly}
                        onChange={onChange}
                        isReport={isReport}
                    />

                    
                    {/* // BUG: Check, we need to fill manual or select company type
                    <SelectCompanyType 
                        label={"Company Type"}
                        name={"uboLegalPersonCompanyType"}
                        value={formData.uboLegalPersonCompanyType}
                        onChange={onChange}
                        country={formData.uboLegalPersonCountryOfIncorporation}
                    /> */}

                    <Input 
                        label={"Company Registration Number"}
                        name={"uboLegalPersonCompanyRegistrationNumber"}
                        value={formData.uboLegalPersonCompanyRegistrationNumber}
                        disabled={isReadOnly}
                        onChange={onChange}
                        isReport={isReport}
                    />

                    <Input 
                        label={"Registered Office Address"}
                        name={"uboLegalPersonRegisteredOfficeAddress"}
                        value={formData.uboLegalPersonRegisteredOfficeAddress}
                        disabled={isReadOnly}
                        onChange={onChange}
                        isReport={isReport}
                    />
                    
                    <MultiTextInput 
                        label={"Name of Directors"}
                        name={"uboLegalPersonDirectors"}
                        disabled={isReadOnly}
                        values={formData.uboLegalPersonDirectors || []}
                        onChange={onChange}
                        isReport={isReport}
                    />

                </>
            )}

            {formData.uboTrusteeType === "Natural Person" && (
                <>
                    <Input
                        label={"Name of Trustee"}
                        name={"uboNaturalPersonName"}
                        value={formData.uboNaturalPersonName}
                        disabled={isReadOnly}
                        onChange={onChange}
                        isReport={isReport}
                    />

                    <Input
                        label={"Nationality"}
                        name={"uboNaturalPersonNationality"}
                        value={formData.uboNaturalPersonNationality}
                        disabled={isReadOnly}
                        onChange={onChange}
                        isReport={isReport}
                    />

                </>
            )}

            <RadioGroup
                label={"Have you obtained a copy of the trust deed?"}
                name={"uboTrustDeedObtained"}
                value={formData.uboTrustDeedObtained}
                disabled={isReadOnly}
                onChange={onChange}
                isReport={isReport}
                options={yesNoOption}
            />

            {formData.uboTrustDeedObtained === "No" && (
                <Input
                    label={"Please explain why you have been unable to obtain a copy of the Trust deed"}
                    name={"uboTrustDeedNotObtainedReason"}
                    value={formData.uboTrustDeedNotObtainedReason}
                    disabled={isReadOnly}
                    onChange={onChange}
                    isReport={isReport}
                />
            )}

        </>
    );
})